"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesService = void 0;
class CompaniesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Companies() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1Companies({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1Companies1({ companyId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/{companyId}',
            path: {
                companyId: companyId,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    putApiV1Companies({ companyId, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/companies/{companyId}',
            path: {
                companyId: companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CompaniesAccesspermissions() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/accesspermissions',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CompaniesRoles() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/roles',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.CompaniesService = CompaniesService;
